import { useSeoMeta } from "@unhead/react";
import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Layout } from "@/components/Layout";
import { Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useSeoMeta({
    title: "404 — Page Not Found | Nostr Missal",
    description: "The page you are looking for could not be found.",
  });

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <div className="flex min-h-[60vh] flex-col items-center justify-center px-4 text-center">
        <p className="text-amber-600 dark:text-amber-500 text-2xl tracking-[0.5em] opacity-60 mb-5 select-none">✦</p>
        <h1 className="mb-3 text-6xl font-semibold text-stone-200 dark:text-stone-700" style={{ fontFamily: '"Cinzel", serif' }}>
          404
        </h1>
        <h2 className="mb-3 text-2xl font-semibold text-stone-800 dark:text-stone-200 sm:text-3xl" style={{ fontFamily: '"Cinzel", serif' }}>
          Page Not Found
        </h2>
        <p className="mb-8 max-w-sm text-stone-500 dark:text-stone-400 leading-relaxed">
          This page does not exist. Return home to continue your liturgical journey.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 rounded-full bg-stone-800 dark:bg-stone-100 px-6 py-2.5 text-sm font-semibold text-white dark:text-stone-900 shadow-sm transition-all hover:opacity-90"
          style={{ fontFamily: '"Cinzel", serif', letterSpacing: '0.06em' }}
        >
          <Home className="h-4 w-4" />
          Return Home
        </Link>
      </div>
    </Layout>
  );
};

export default NotFound;
